var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"l-header",class:{
        'l-header--light': _vm.isStoryLightMode && _vm.district.id,
        'l-header--transparent': _vm.transitionOutUrl
    }},[_c('div',{staticClass:"l-header__inner | grid"},[_c('navigation')],1),_c('navigation-mobile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }